import Cookies from 'js-cookie';

export const isLoggedIn = (): boolean => {
  return !!Cookies.get('user_access_token');
};
